import React, { PropsWithChildren } from "react";

import styles from "./index.module.scss";

/** Class names you can apply to inputs within a FormLayout to alter how they flow */
export const FormLayoutFlags = {
  /** Render a component half the width of the form if there's reasonable space to do so — you will usually want to put two of these together for it to accomplish anything */
  halfWidth: styles.halfWidth,
};

/** Wrap all the elements of a form in this and they will stack neatly one on top of the next, with appropriate margins, unless you explicitly flag them to do something else. */
export default function FormLayout({ children }: PropsWithChildren<unknown>) {
  return <div className={styles.Container}>{children}</div>;
}
